import icon from "@material-ui/icons/Payment"

export default { icon } ;